export default "__VITE_ASSET__BWrvV7QT__"